import Link from "@/components/ui/RouterLink";

export function Logo() {
  return (
    <Link href="/" className="focus-ring flex items-center gap-2.5" aria-label="The Planet — home">
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none" aria-hidden="true">
        <circle cx="15" cy="15" r="12.5" stroke="#25C7FF" strokeWidth="1.4" />
        <circle cx="15" cy="15" r="7" stroke="#397BFF" strokeWidth="1.2" />
        <circle cx="15" cy="15" r="2" fill="#25C7FF" />
        <circle cx="24" cy="10" r="1.4" fill="#397BFF" />
        <circle cx="6" cy="20" r="1.4" fill="#397BFF" />
        <path d="M15 2.5v5M15 22.5v5M2.5 15h5M22.5 15h5" stroke="#2864FF" strokeWidth="0.8" opacity="0.5" />
      </svg>
      <span className="font-display text-[15px] font-semibold tracking-[0.08em] text-text-primary">
        THE PLANET
      </span>
    </Link>
  );
}
